import Api from './baseService';
import type { AccountUserViewModel } from '@/models/account';

async function getUserAccounts(): Promise<AccountUserViewModel[]> {
  const response = await Api.get('accounts');
  return response.data as AccountUserViewModel[];
}

export {
  getUserAccounts,
}
